import "./NewLayout.css";
import { superadminSideBarItems } from "../pages/sharedPages/NewSidebar/SuperAdminSideBar";

import { Outlet, ScrollRestoration } from "react-router-dom";
import { useDispatch } from "react-redux";
import NewSidebar from "../pages/sharedPages/NewSidebar/NewSidebar";
import ProfileDropdown from "../pages/sharedPages/ProfileDropdown/ProfileDropdown";
import React, { useEffect } from "react";
import useApi from "../helpers/apiHelper/requestHelper";
import { toastify } from "../helpers/toast/toastify";
import { fetchAdmin } from "../helpers/helper";
import { storeUser } from "../redux/users/usersSlice";

const AdminLayout = () => {
  const api = useApi();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchAdmin(api, dispatch, storeUser);
  }, []);

  return (
    <div className="newLayoutBox">
      <div className={`sideBarBox`}>
        <NewSidebar items={superadminSideBarItems} />
      </div>
      <div className={`mainContentBox `}>
        <div className={`container-fluid g-0`}>
          {/* <Pagination/>  */}
          <div className="layoutTitleBox">
            <div className="row g-0">
              <div className="col-lg-6 col-md-6 col-12 order-lg-1 order-md-1 order-2">
                {/* <h2 className="Pagetitle">{currentPageTitle}</h2> */}
              </div>
              <div className="col-lg-6 col-md-6 col-12 order-lg-2 order-md-2 order-1">
                <div className="settingProfileBox">
                  <ProfileDropdown />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Outlet />
        <ScrollRestoration />
      </div>
    </div>
  );
};

export default AdminLayout;
